import { createSlice } from '@reduxjs/toolkit';
import {
  fetchUserInfoBuilder,
  loginBuilder,
  logoutBuilder,
  refreshBuilder,
  resetPasswordBuilder,
  sendCodeForNewPasswordBuilder,
  signUpBuilder,
} from './builder';

const initialState = {
  email: '',
  loggedIn: false,
  loginPending: false,
  error: null,
  token: null,
  createAccountPending: false,
  sendingResetEmailPending: false,
  resettingPasswordPending: false,
  sendVerificationCodeEmailAgainPending: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoggedIn: (state, { payload }) => {
      const { loggedIn } = payload;
      state.loggedIn = loggedIn;
    },
    setEmailInput: (state, { payload }) => {
      state.email = payload;
    },
    setAccessToken: (state, { payload }) => {
      const { accessToken } = payload;
      state.token = accessToken;
    },
  },
  extraReducers: builder => {
    signUpBuilder(builder);
    loginBuilder(builder);
    refreshBuilder(builder);
    fetchUserInfoBuilder(builder);
    logoutBuilder(builder);
    sendCodeForNewPasswordBuilder(builder);
    resetPasswordBuilder(builder);

    builder.addCase('logout', () => ({ ...initialState, loggedIn: false }));
  },
});

export const { setLoggedIn, setEmailInput, setAccessToken } = authSlice.actions;

export const selectLoggedIn = state => state.auth.loggedIn;

export const selectEmailInput = state => state.auth.email;

export const selectCreateAccountPending = state => state.auth.createAccountPending;

export const selectLoginPending = state => state.auth.loginPending;

export const selectSendingResetPending = state => state.auth.sendingResetEmailPending;

export const selectResetPasswordPending = state => state.auth.resettingPasswordPending;

export const selectSendVerificationCodeEmailAgainPending = state => state.auth.sendVerificationCodeEmailAgainPending;

export default authSlice.reducer;
